// @ts-strict-ignore
import { useQuery as _useQuery } from '@tanstack/react-query';
import log from '~/helpers/logging';

export type QueryData<D> = {
  data?: D;
  hasError: boolean;
  isLoading: boolean;
};

const useQuery = <D>({
  errorLogMessage = 'Error occurred while getting and parsing chart data',
  initialData,
  queryKey,
  queryFn,
  onError,
}: {
  errorLogMessage?: string;
  initialData?: D;
  queryKey: string[];
  queryFn: () => Promise<D>;
  onError?: (e: Error) => void;
}): QueryData<D> => {
  const {
    data,
    isError: hasError,
    isLoading,
  } = _useQuery({
    // @ts-ignore Tried defining generics for each of the args that are passed through from the outer fn, as recommended here (https://twitter.com/TkDodo/status/1491451513264574501), but that didn't work.
    initialData,
    onError: (e: Error) => {
      log('error', errorLogMessage, {}, e);
      if (onError) {
        onError(e);
      }
    },
    queryKey,
    queryFn,
  });

  return {
    data,
    hasError,
    isLoading,
  };
};

export default useQuery;
